import { DataAccessRouteParams } from '@security/access/DataAccessView';
import { getQueryString } from '@sonar-software/sonar-http';

import { FULL_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';

export function getInitiativeRoute(initiativeId: number | undefined): string {
	return FULL_ROUTES.INITIATIVES_DETAIL.replace(PARAMS.ID, initiativeId?.toString() ?? '');
}

export function getMonitorRoute(applicationId: number | undefined): string {
	return FULL_ROUTES.MONITORS.replace(PARAMS.ID, applicationId?.toString() ?? '');
}

export function getDataAccessRoute(params?: DataAccessRouteParams): string {
	const { accessId, accessName, accessType, objectName, type } = params || {};
	const { id, ...rest } = params || {};

	if (accessId?.length && accessType?.length) {
		return objectName ?
			FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_COMPARE_FIELDS
				.replace(PARAMS.OBJECT_ID, objectName)
				.concat(`?${getQueryString(rest)}`) :
			FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_COMPARE
				.concat(`?${getQueryString(rest)}`);
	}

	if (accessName && type && id) {
		return objectName ?
			FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_EXPLAINER_FIELDS
				.replace(PARAMS.ID, id)
				.replace(PARAMS.OBJECT_ID, objectName)
				.concat(`?${getQueryString(rest)}`) :
			FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_EXPLAINER
				.replace(PARAMS.ID, id)
				.concat(`?${getQueryString(rest)}`);
	}


	return objectName ? FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_AUDIT
		.replace(PARAMS.OBJECT_ID, objectName)
		.concat(`?${getQueryString(rest)}`) :
		FULL_ROUTES.DATA_SECURITY_DATA_ACCESS;
}
